import store from '../store'
var headers = () => {
  return { headers: { token: store.state.user.jwt, app: 'ADMIN' } }
}
export default headers
